@if (isPageInitialized) {
  <div class="dashboard-top-section d-flex align-items-center justify-content-between" *transloco="let t; prefix: 'parts'">
    <h1 class="secondary">{{ t('title') }}</h1>
    <div class="search-menu-lists d-flex">
      <div class="filters d-flex align-items-center gap-2">
        <!-- @if (selectedTab === 'inventory') {
          <app-notification-icon [notificationCount]="233"></app-notification-icon>
        } -->
        <div id="spacer"></div>
        <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

        @if (selectedTab !== 'inventory') {
          <app-date-filter
            [filter]="dateFilter"
            [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals"
            [defaultInterval]="defaultInterval"
            (filterChanged)="onPartsDateFilterChange($event)">
          </app-date-filter>
        }

        @if (selectedTab === 'inventory') {
          <input type="file" hidden #excelFileInput accept=".xlsx,.xls,.csv" (change)="onExcelFileSelectedAsync($event)">
          <button class="btn btn-secondary upload-excel-btn" type="button" aria-expanded="false" (click)="excelFileInput.click()">
            <span>{{ t('actions.uploadExcel') }}</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <rect width="24" height="24" fill="url(#pattern0_28988_88665)" />
              <defs>
                <pattern id="pattern0_28988_88665" patternContentUnits="objectBoundingBox" width="1" height="1">
                  <use xlink:href="#image0_28988_88665" transform="scale(0.02)" />
                </pattern>
                <image
                  id="image0_28988_88665"
                  width="50"
                  height="50"
                  preserveAspectRatio="none"
                  xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEQ0lEQVR4nO3Zb0wTdxzHcZ4rlNL27kxcUpKFLdmgtkgPitIWWlH+FOcmIMXgqi1/hpuMCaWItEBxTMyCcXOLE5Ea5cnGk5mNICHbGifJ3Fx2M1nczDBZlpnFLHFxINDP0usgQdpC2gs/s9w3eT9o0wf36u/3uzZtQoI44ogjzv9+UodrDyp99qtKn2M8llQTrhGN3zMeU1+5T2lvdCYJgTCn+hyIJ9VE+51MvwexpvF7PogbovQ5OkhDMv2e7+NfEZ/dTRqi8bs5EbI4IsT3tEGGbB7l4EGsqQuHkHrRTg5C9e7O2XSi1EEt1lMcqqvYwXjLxhjvbjA9wcpCdS9mAdMViu4q5V+z+d0qKM/b1h/C9JU1MCcsoHuDlYL2loDqKQbVXQSqqwgKzy4o3DuhcBdC3lkI+fEdkHeYITtmgqy9ADJXAVJc+UhpMyLFaQDVZvojta/ietr5Q188P1w3GSx9zPnplgnXZKylj7uurA7pLZ0SCiFt1SOlxYCs3hrknm2AfqiJ77nhup/jOmfD9h9X31ZeCycUQtqih/RoHrZ6a6A7Uw/9hXWFlHBCIpLf2k4KUsyFQ7CnbSj4sBHsgG0Z4hl3MYzv1cF4phZ0u2kFIrl5GxmIoqeIC7cSjaP9CM7M3CxefKdyaSVOfznCP++/eyu0Gk8gyEG6i7hw20nRWYgbv/7AX/S5r0d5xAtvl+PR4xnMzs9B278/LELyZi4hiKeIi3QmjO/XYyEQ4C9cfbIKI9+O8bC+a0MREZImHRmI3L2Li3awL33zWWgr/fIdFgILuPvnb2Bc5ogIyZEcQpDOnVy0u1Oadw/++uchFqdisDUqIumNbFKQHVy0W6yqrxJ/zz5aglQOOqMikl7Phrw0A1R5Jphqlk/aakDysfzYcxpm1gaJ8jlx7acpHvDR9VEEAgFMP/gdm5ymiIikwywhyHEzFwlRO9LDI+7cvwdFqxEf35rgHw9MXo6ISDysJQTpMHHhEM92WXD/4QP+wvdfbOe3k8q7F7PzjzG3MI/t/QfCIhIbs8hAZO0mLtzXjis3P+cRN+/dDh3u/87EOf8noeenb0PapFuBSHxtKyGIq4B7EhHMMGCHccCONE/ZsoO9uc0M/alXkdd/AHSzfgViYwMpSFsBF+0LYLS7UzjExvpMMpCUtnxOSMSGOg0ZiNRpmBISscGhJgRp1dcLhqhVI8mqgtyiWgah7Doo6nJjz6GbXhXCb68Wfbb0aJ5D0rxteUdyHNKazHHpPjUWSw5WuSVURTAVJMHKVZC+nAFZSTqol9SgK7KWIHFnZeP/OYiyZPQF3+E1VaaCYo+aXw1631MGoV9Re6m9GqypIKBCYES1UJBK1kNXabHWGKtWWES1UBAr6xb8wkRIHMNY2Q7yEG38f/RQ1ayZNIS2smcThBjaqrXRVu1VxqodX+9oK3tSZtMlCgIRRxxxxEkgNf8Cr5YkvJs7/z0AAAAASUVORK5CYII=" />
              </defs>
            </svg>
          </button>
          <button class="btn btn-secondary upload-excel-btn download-template-btn" type="button" (click)="onDownloadTemplateClicked()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M7.99967 10.666L10.6663 7.33268H8.66634V2.66602H7.33301V7.33268H5.33301L7.99967 10.666Z" fill="#EE2737"/>
              <path d="M13.333 12.0007H2.66634V7.33398H1.33301V12.0007C1.33301 12.736 1.93101 13.334 2.66634 13.334H13.333C14.0683 13.334 14.6663 12.736 14.6663 12.0007V7.33398H13.333V12.0007Z" fill="#EE2737"/>
            </svg>
            <span>{{ t('actions.downloadTemplate') }}</span>
          </button>
          <button class="btn btn-primary add-part-btn" type="button" aria-expanded="false" (click)="onAddPartClick()">
            <span>{{ t('actions.addPart') }}</span>
          </button>
        }

        @if (selectedTab === 'parts-usage') {
          <button class="btn btn-primary add-part-btn" type="button" aria-expanded="false" (click)="onReturnPartsClick($event)">
            <span>{{ t('actions.returnPart') }}</span>
          </button>
        }
      </div>
    </div>
  </div>

  <div class="row gx-4">
    <div class="col-lg-3 col-md-6">
      <app-total-parts-widget></app-total-parts-widget>
    </div>
    <div class="col-lg-3 col-md-6">
      <app-out-of-stock-widget></app-out-of-stock-widget>
    </div>
    <div class="col-lg-3 col-md-6">
      <app-inventory-value-widget></app-inventory-value-widget>
    </div>
    <div class="col-lg-3 col-md-6">
      <app-low-stock-widget></app-low-stock-widget>
    </div>
  </div>
  <div class="tabs-container w-100" *transloco="let t; prefix: 'parts'">
    <button class="tab-button" [class.active]="isTabActive('inventory')" (click)="onTabChange('inventory')">{{ t('tabs.inventory') }}</button>
    <button class="tab-button" [class.active]="isTabActive('parts-request')" (click)="onTabChange('parts-request')">{{ t('tabs.partsRequest') }}</button>
    <button class="tab-button" [class.active]="isTabActive('parts-usage')" (click)="onTabChange('parts-usage')">{{ t('tabs.partsUsage') }}</button>
  </div>

  <div class="w-100">
    @if (selectedTab === 'inventory') {
      <app-inventory-overview
        [accountIds]="accountFilter?.accountIds ?? []"
        [accountsLoaded]="isAccountFilterLoaded"
        [refreshTrigger]="refreshInventoryVersion"
        [dateFilter]="dateFilter">
      </app-inventory-overview>
    } @else if (selectedTab === 'parts-request') {
      <app-parts-request-overview></app-parts-request-overview>
    } @else if (selectedTab === 'parts-usage') {
      <app-parts-usage-overview></app-parts-usage-overview>
    }
  </div>
}